import Section from "../../components/Common/Section";
import Divider from "../../components/Common/Divider";
import Heading from "../../components/Common/Heading";
import { useFetchIzobrazevanjeWithSifranti, useAddIzobrazevanjeDraft } from "./IzobrazevanjeHooks";
import ApiStatus from "../../components/ApiStatus";
import IzobrazevanjeJavnoForm from "./IzobrazevanjeJavnoForm";
import getApiExceptionObjectFromAxiosError from "../../utils/ProcessException";
//import { IzobrazevanjeJavnoFormType } from "../../types/Izobrazevanje/IzobrazevanjeJavnoFormType";

const IzobrazevanjeJavnoAdd = () => {
    const { data, status, isSuccess } = useFetchIzobrazevanjeWithSifranti(0);
    const addIzobrazevanjeJavnoMutatiedDraft = useAddIzobrazevanjeDraft();

    if (!isSuccess)
        return (
            <Section>
                <Heading>Dodajanje javne objave
                    <Divider />
                </Heading>
                <ApiStatus status={status}></ApiStatus>
            </Section>
        )

    return (
        <Section>
            <Heading>
            Dodajanje javne objave
                <Divider />
                <p>
                    <span className="red">*</span>
                    polja, označena z zvezdico, so obvezna
                </p>
            </Heading>
            <IzobrazevanjeJavnoForm
                key={data.izobrazevanje.izobrazevanjeId}
                izobrazevanje={data.izobrazevanje}
                izobrazevanjeTipi={data.izobrazevanjeTipi}
                onSaveDraft={async (izobrazevanje, onSuccessCallback) =>
                    await addIzobrazevanjeJavnoMutatiedDraft.mutateAsync({
                        izobrazevanje,
                        onSuccessCallback, // Pass the callback as part of the variables
                    })
                }
                apiException={getApiExceptionObjectFromAxiosError(addIzobrazevanjeJavnoMutatiedDraft?.error)}
            />
        </Section>
    );
}

export default IzobrazevanjeJavnoAdd;